import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetComparativeTableV2QueryResponse, GetComparativeTableV2QueryParams, GetComparativeTableV2400, GetComparativeTableV2401, GetComparativeTableV2403, GetComparativeTableV2422, GetComparativeTableV2429, GetComparativeTableV2500 } from "../types/GetComparativeTableV2";

export const getComparativeTableV2QueryKey = (params: GetComparativeTableV2QueryParams) =>     [{url:`/api/purchase-tenders/v2/comparative-table`},...(params ? [params] : [])] as const;
      export function getComparativeTableV2QueryOptions <TData = GetComparativeTableV2QueryResponse, TError = GetComparativeTableV2400 | GetComparativeTableV2401 | GetComparativeTableV2403 | GetComparativeTableV2422 | GetComparativeTableV2429 | GetComparativeTableV2500>(params: GetComparativeTableV2QueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getComparativeTableV2QueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v2/comparative-table`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v2/comparative-table
 */

export function useGetComparativeTableV2 <TData = GetComparativeTableV2QueryResponse, TError = GetComparativeTableV2400 | GetComparativeTableV2401 | GetComparativeTableV2403 | GetComparativeTableV2422 | GetComparativeTableV2429 | GetComparativeTableV2500>(params: GetComparativeTableV2QueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getComparativeTableV2QueryKey(params);

  const query = useQuery<TData, TError>({
    ...getComparativeTableV2QueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
